const FIELDS = "input:not([type=hidden]):not([type=file]):not([type=checkbox]):not([type=radio]):not([disabled]):not([readonly]):not([data-skip-enter]), textarea:not([disabled]), "
  + "button[role=combobox]:not([disabled]), [data-field]:not([disabled]), [data-save]:not([disabled])";

// Next field in the same dialog (Tally-style Enter); after the last field it lands on the Save button.
export function focusNext(from) {
  if (!from) return;
  const root = from.closest?.("[role=dialog]") || document.body;
  const list = [...root.querySelectorAll(FIELDS)].filter((el) => el.offsetParent !== null && !el.closest("[data-dialog-close]"));
  const i = list.indexOf(from);
  const next = i >= 0 ? list[i + 1] : list.find((el) => !from.contains(el) && (from.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING));
  if (!next) return;
  next.focus();
  if (next.tagName === "INPUT") { try { next.select(); } catch { /* not selectable */ } }
}

// Dialog keyboard: Ctrl+A / Ctrl+S = Save, Enter in a field = go to the next field (textarea keeps its new line).
export function dialogKeys(e) {
  if (e.defaultPrevented || e.nativeEvent?.isComposing) return;
  const dlg = e.currentTarget;
  const tg = e.target;
  if (!(tg instanceof Element) || !dlg.contains(tg)) return;
  const k = (e.key || "").toLowerCase();
  if ((e.ctrlKey || e.metaKey) && !e.altKey && !e.shiftKey && (k === "a" || k === "s")) {
    const vis = (sel) => [...dlg.querySelectorAll(sel)].filter((b) => b.offsetParent !== null);
    const save = vis("[data-save]").pop() || vis("[data-dialog-footer] button").pop();
    if (!save) return;
    e.preventDefault();
    if (!save.disabled) save.click();
    return;
  }
  if (e.key !== "Enter" || e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) return;
  if (tg.tagName !== "INPUT" || ["checkbox", "radio", "file", "submit", "button"].includes(tg.type)) return;
  e.preventDefault();
  focusNext(tg);
}
